import React from "react";
import { errorToast } from "./common/showtoast";
import PageHeader from "./common/pageheader";
import ApiRequest from "./common/restservice";

export default class PaidSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: []
    }
  }
  componentDidMount() {
    this.GetTransactions();
  }
  async GetTransactions() {
    let res = await ApiRequest("GetPaidReport.asp", "GET", null, { Authorization: localStorage.getItem("token") });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState({
      tableData: res.items
    })
  }
  render() {
    return (
      <div>
        <PageHeader title="Paid Summary" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                    Paid Summary
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>Ac. NO</th>
                        <th>Name</th>
                        <th>Bank</th>
                        <th>Branch</th>
                        <th>Date</th>
                        <th>IFSC</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.tableData.length <= 0 ? <tr>
                          <td colSpan="8">No Details Found</td>
                        </tr> :
                          this.state.tableData.map((item, index) => (
                            <tr key={index}>
                              <td className="tabletd">{(index + 1)}</td>
                              <td>{item.account_number}</td>
                              <td>{item.AccountHolderName}</td>
                              <td>{item.Bank_name}</td>
                              <td>{item.Branch_Name}</td>
                              <td>{item.IFSC}</td>
                              <td>{item.amount}</td>
                              <td>{item.payoutdate}</td>
                            </tr>
                          ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}